import {useInfiniteQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS,Paginated, EsimCompatibleDevice, getSearchParamFromUrl} from '@chekin/core';
import {useReservation} from 'context/reservation';
import {API} from '@chekin/api';

type InfinityProps = {
  query?: string;
  os?: 'ios' | 'android';
};
function useInfiniteFetchCompatibleDevices({query, os}: InfinityProps) {
  const {housingId} = useReservation();

  return useInfiniteQuery<Paginated<EsimCompatibleDevice>, Error>({
    queryKey: [QUERY_CACHE_KEYS.esimFeature, query, os],
    queryFn: ({pageParam}) =>
      API.upselling.getCompatibleDevices(
        `page=${pageParam}&page_size=10&q=${query}&os=${os}`,
      ),
    initialPageParam: 1,
    getNextPageParam: lastGroup => {
      if (lastGroup?.next) {
        return Number(getSearchParamFromUrl('page', lastGroup.next));
      }
    },
    enabled: Boolean(housingId),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export {useInfiniteFetchCompatibleDevices};
